export const getNativePeriodDates = (period) => {
  const now = new Date();
  let start, end;

  switch (period.toLowerCase()) {
    case 'month':
      start = new Date(now.getFullYear(), now.getMonth(), 1);
      end = new Date(now.getFullYear(), now.getMonth() + 1, 0);
      break;
    case 'week': {
      const day = now.getDay(); // 0 (dimanche) à 6 (samedi)
      const diffToMonday = (day + 6) % 7; // ramène dimanche à 6, lundi à 0...
      start = new Date(now);
      start.setDate(now.getDate() - diffToMonday);
      end = new Date(start);
      end.setDate(start.getDate() + 6);
      break;
    }
    case 'day':
      start = new Date(now);
      end = new Date(now);
      break;
    default:
      return 'N/A';
  }

  return `${formatDate(start)} - ${formatDate(end)}`;
};

const formatDate = (date) => {
  return date.toLocaleDateString('fr-FR');
};
